export type HttpStatusManager = {
  getStatus: () => number;
  reset: () => void;
  setStatus: (status: number) => void;
};

export const createHttpStatusManager = (): HttpStatusManager => {
  let status = 200;

  return {
    getStatus: () => status,
    reset: () => { status = 200; },
    setStatus: value => { status = value; }
  };
};
